import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {ToastContainer, toast} from 'react-toastify';
import {ON_API_ERROR} from '../../../actions/types';

class ErrorHandlerComponent extends PureComponent {
  static propTypes = {
    error: PropTypes.shape().isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  componentDidUpdate() {
    const {error = {}} = this.props;
    const {error: errorMessage} = error;
    if (errorMessage) {
      this.showError(errorMessage);
    }
  }

  showError = (message) => {
    const options = {
      position: toast.POSITION.TOP_CENTER,
      hideProgressBar: true,
      onClose: () => {
        this.props.dispatch({type: ON_API_ERROR, error: null});
      },
    };
    toast.error(message, options);
  };

  render() {
    return <ToastContainer autoClose={5000}/>;
  }
}

function mapStateToProps({error}) {
  return {
    error,
  };
}
export default connect(mapStateToProps)(ErrorHandlerComponent);
